import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { showHideFilterModalReducer } from "../../../data/redux/slice/globalFiltersSlice";
import {
  fetchClientDropDownList,
  fetchResellerDropDownList,
  fetchResellerServiceProviderDropDownList,
  fetchServiceProviderDropDownList,
} from "../../../services/fetchDropdownListData";
import CustomModal from "../main_comps/custom_modal";
import GlobalFilters from "./global_filters/GlobalFilters";
import TopHeaderComponent from "./TopHeaderComponent";
import secureStorage from "../../../services/secureStorage";
import {
  SS_INTERNAL,
  SS_ROLE,
} from "../../../utility/constants/secureStorageManager";
import { CLIENT, RESELLER } from "../../../utility/constants/valueConstants";

function MainComponent({
  filterRequired = true,
  notificationRequired = true,
  backActionRequired = false,
  onClickFilter,
  onClickFilterCall,
  headerTitle = "",
  customButtonRequired,
  dashboardFilterrequired,
  currentServiceType = "",
  headerStyle,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const filter = useSelector((state) => state.globalFiltersSlice);
  const role = secureStorage.getItem(SS_ROLE);
  const internal = secureStorage.getItem(SS_INTERNAL);

  useEffect(() => {
    if (internal && role === CLIENT) {
      dispatch(fetchResellerDropDownList());
      if (role?.toUpperCase() === RESELLER) {
        dispatch(fetchResellerServiceProviderDropDownList());
      } else {
        dispatch(fetchServiceProviderDropDownList());
      }
    }
  }, []);
  useEffect(() => {
    dispatch(
      fetchClientDropDownList(
        currentServiceType
          ? currentServiceType
          : internal
          ? currentServiceType
          : "van"
      )
    );
  }, [currentServiceType]);
  return (
    <div
      style={{
        width: "100%",
        padding: "20px 20px",
        borderBottom: location.pathname !== "/dashboard" && "1px solid #f3f3f3",
      }}
    >
      <TopHeaderComponent
        filterRequired={filterRequired}
        notificationRequired={notificationRequired}
        backActionRequired={backActionRequired}
        onClickFilter={onClickFilter}
        headerTitle={headerTitle}
        customButtonRequired={customButtonRequired}
        dashboardFilterrequired={dashboardFilterrequired}
        headerStyle={headerStyle}
      />
      {filter.showFilterModal && (
        <CustomModal
          headerTitle={"Filter"}
          open={filter.showFilterModal}
          onClose={() => {
            dispatch(
              showHideFilterModalReducer({
                showFilterModal: false,
                filters: [],
              })
            );
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 400,
            height: "auto",
          }}
        >
          <GlobalFilters
            onClickFilterCall={onClickFilterCall}
            currentServiceType={currentServiceType}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default MainComponent;
